import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export interface ControlGroupSurfaceProps extends React.HTMLAttributes<HTMLDivElement> {
  fill?: boolean;
  invalid?: boolean;
}

const ControlGroupSurface = forwardRef<
  HTMLDivElement,
  ControlGroupSurfaceProps
>(({ className, fill, invalid, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    data-invalid={invalid || undefined}
    className={twMerge(
      clsx(
        "control-group-surface relative flex min-h-(--control-group-height,38px) w-full min-w-0 items-stretch rounded-sm border border-gunmetal-200 bg-white transition-all",
        "[&_svg]:size-(--control-group-icon-size,21px)",
        "[&>.control-group-segment:first-child]:rounded-s-[inherit] [&>.control-group-segment:last-child]:rounded-e-[inherit]",
        "[&>.control-group-segment:first-child>:first-child]:rounded-s-[inherit] [&>.control-group-segment:last-child>:last-child]:rounded-e-[inherit]",
        "[&>.control-group-segment:last-child>[aria-expanded]]:rounded-e-[inherit]",
        "[&>.control-group-segment:has(>.control-group-action)+.control-group-segment:has(>.control-group-action)]:border-s-0!",
        invalid &&
          "border-red-500 [&>.control-group-segment:focus-within]:outline-red-500 [&>.control-group-segment:focus-within]:ring-red-400/25 [&>.control-group-segment:has([aria-expanded=true])]:outline-red-500 [&>.control-group-segment:has([aria-expanded=true])]:ring-red-400/25",
        fill && "h-full",
      ),
      className,
    )}
  />
));

export default ControlGroupSurface;
